<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col xl="12">
        <b-card header="Información de la Órden">
          <b-form>
            <b-form-group
              label="Rubro"
              label-for="rubro"
              :label-cols="labelCols"
              horizontal>
              <b-form-input 
                id="rubro"
                :value="rubroTrabajo" 
                readonly
                type="text">
              </b-form-input>
            </b-form-group>

            <b-form-group
              label="Título"
              label-for="titulo"
              :label-cols="labelCols"
              horizontal>
              <b-form-input 
                id="titulo"
                v-model.trim= "$v.titulo.$model" 
                :state="tituloValido"
                :readonly="readOnly"
                type="text"
                @blur.native="validate">
              </b-form-input>
              <b-form-invalid-feedback id="tituloFeedback">
                {{ tituloInvalidoMsj }}
              </b-form-invalid-feedback>          
            </b-form-group>

            <b-form-group
              label="Descripción"
              label-for="descripcion"
              :label-cols="labelCols"
              description="Descripción a incluir en el Presupuesto al Cliente"
              horizontal>
              <b-form-textarea
                id="descripcion"
                :readonly="readOnly"
                v-model="$v.descripcion.$model" 
                rows="3"
                max-rows="3"
                :state="descripcionValida"
                @blur.native="validate">
              </b-form-textarea>
              <b-form-invalid-feedback id="descripcionFeedback">
                {{ descripcionInvalidaMsj }}
              </b-form-invalid-feedback>          
            </b-form-group>

            <b-form-group
              label="Moneda"
              label-for="moneda"
              :label-cols="labelCols"
              horizontal>
              <b-form-input 
                id="moneda"
                :value="moneda" 
                readonly
                type="text">
              </b-form-input>
            </b-form-group>

            <b-row>
              <b-col cols="12" md="6">
                <b-form-group
                  label="Cantidad"
                  label-for="cantidad"
                  :label-cols="labelCols * 2"
                  horizontal>
                  <b-form-input 
                    id="cantidad"
                    v-model.trim="$v.cantidad.$model" 
                    :state="cantidadValida"
                    type="text"
                    @blur.native="validate"
                    @input.native="calcularCostos">
                  </b-form-input>
                  <b-form-invalid-feedback id="cantidadFeedback">
                    {{ cantidadInvalidaMsj }}
                  </b-form-invalid-feedback>          
                </b-form-group>
              </b-col>
            </b-row>

            <b-row>
              <b-col cols="12" md="6">
                <b-form-group
                  label="Costo Unitario"
                  label-for="costoEstimado"
                  description="Costo Unitario IVA no incluido"
                  :labelCols="labelCols * 2">
                  <b-input-group>
                    <b-input-group-prepend is-text>
                      <b-form-radio v-model="costoUnitario" 
                        name="costoUnitarioSelected" 
                        :value="Boolean(true)"
                        class="radio-group">
                      </b-form-radio>
                    </b-input-group-prepend>
                    <b-form-input 
                      id="costoEstimado" 
                      v-model.trim= "$v.costoEstimado.$model" 
                      type="text"
                      :readonly="costoDisabled"
                      :state="costoEstimadoValido"
                      @blur.native="validate"
                      @input.native="calcularCostoTotal">
                    </b-form-input>
                  </b-input-group>
                  <b-form-invalid-feedback id="costoEstimadoFeedback">
                    {{ costoEstimadoInvalidoMsj }}
                  </b-form-invalid-feedback>          
                </b-form-group>
              </b-col>
              <b-col cols="12" md="6">
                <b-form-group
                  label="Costo Total"
                  label-for="costoEstimadoTotal"
                  description="Costo Total IVA no incluido"
                  :labelCols="labelCols * 2">
                  <b-input-group>
                    <b-input-group-prepend is-text>
                      <b-form-radio v-model="costoUnitario" 
                        name="costoTotalSelected" 
                        :value="Boolean(false)"
                        class="radio-group">
                      </b-form-radio>
                    </b-input-group-prepend>
                    <b-form-input 
                      id="costoEstimadoTotal" 
                      v-model.trim= "$v.costoEstimadoTotal.$model" 
                      type="text"
                      :readonly="costoTotalDisabled"
                      :state="costoEstimadoTotalValido"
                      @blur.native="validate"
                      @input.native="calcularCostoUnitario">
                    </b-form-input>
                  </b-input-group>
                  <b-form-invalid-feedback id="costoEstimadoTotalFeedback">
                    {{ costoEstimadoTotalInvalidoMsj }}
                  </b-form-invalid-feedback>          
                </b-form-group>
              </b-col>
            </b-row>
          </b-form>

          <div slot="footer">
            <b-button size="sm" variant="primary" class="footer-button"
              @click.prevent="save">Grabar</b-button>
            <b-button size="sm" variant="danger" class="footer-button"
              @click.prevent="goBack">Cerrar</b-button>
          </div>
        </b-card>
      </b-col>
    </b-row>

    <app-mensaje
      :modalMsj="modalMsj"
      :modalMensaje="modalMensaje"
      @okAction="okAction"
      @hiddenAction="hiddenAction">
    </app-mensaje>
  </div>
</template>

<script>
import Mensaje from  '../shared/msjModal.vue';
import { msjModal } from '../../mixins/modalDialogs'

// import ABMButtons from '../shared/abmButtons.vue';
/*import SearchProveedor from '../proveedores/SearchList.vue';*/
import { required, numeric, decimal, minValue, maxLength } from 'vuelidate/lib/validators';
import { createHelpers } from 'vuex-map-fields';

const { mapFields } = createHelpers({
  getterType: 'ordenTrabajoAlternativa/getField',
  mutationType: 'ordenTrabajoAlternativa/updateField',
});

export default {
  name: 'OrdenesTrabajosAlternativa',
  components: {
    appMensaje: Mensaje
  },
  mixins: [ 
    msjModal, 
  ],
  props: {
    altaOrden: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      noValidar: true,
      tituloValido: null,
      tituloInvalidoMsj: '',
      descripcionValida: null,
      descripcionInvalidaMsj: '',
      cantidadValida: null,
      cantidadInvalidaMsj: '',
      costoEstimadoValido: null,
      costoEstimadoInvalidoMsj: '',
      costoEstimadoTotalValido: null,
      costoEstimadoTotalInvalidoMsj: '',

      labelCols: 2,

      readOnly: false
    }
  },
  computed: {
    ...mapFields([
      'ordenTrabajoAlternativa',

      'rubroTrabajo',
      'categoriaServicio',
      'moneda',

      'titulo',
      'descripcion',
      'cantidad',
      'costoEstimado',
      'costoEstimadoTotal',
      'costoUnitario'
    ]),
    costoDisabled() {
      return !this.costoUnitario;
    },
    costoTotalDisabled() {
      return Boolean(this.costoUnitario);
    },
  },  
  created() {
  }, 
  methods: {
    validate(event) {
      if (event) {
        if (event.target) {
          /* Antes de intentar registrar por primera vez, no validamos */
          if (!this.noValidar) {
            this.$v.$touch();
            this.displayErrores(event.target.id);
          }
        }
      } 
    },
    displayErrores(field) {
      var validarTodos = false;
      var campo = '';

      if (field) {
        campo = field;
      } else {
        validarTodos = true;
      }

      if (campo == 'titulo' || validarTodos) {
        if (this.$v.titulo.$error) {
          this.tituloValido = false;
          if (!this.$v.titulo.required) {
            this.tituloInvalidoMsj= 'Debe ingresar el título de la orden.';
          } else if (!this.$v.titulo.maxLength) {
            this.tituloInvalidoMsj = 'El título sólo puede contener hasta 30 caracteres';
          }
        } else {
          this.tituloValido = null;
          this.tituloInvalidoMsj = '';
        }
      }

      if (campo == 'descripcion' || validarTodos) {
        if (this.$v.descripcion.$error) {
          this.descripcionValida = false;
          if (!this.$v.descripcion.maxLength) {
            this.descripcionInvalidaMsj = 'La descripción sólo puede contener hasta 5000 caracteres';
          }
        } else {
          this.descripcionValida = null;
          this.descripcionInvalidaMsj = '';
        }
      }

      if (campo == 'cantidad' || validarTodos) {
        if (this.$v.cantidad.$error) {
          this.cantidadValida = false;
          if (!this.$v.cantidad.numeric) {
            this.cantidadInvalidaMsj = 'La cantidad debe ser un valor numérico positivo';
          } else {
            if (!this.$v.cantidad.minValue) {
              this.cantidadInvalidaMsj = 'La cantidad ingresada no es válida';
            }      
          }
        } else {
          this.cantidadValida = null;
          this.cantidadInvalidaMsj = '';
        }
      }

      if (this.costoUnitario) {
        if (campo == 'costoEstimado' || validarTodos) {
          if (this.$v.costoEstimado.$error) {
            this.costoEstimadoValido = false;
            if (!this.$v.costoEstimado.decimal || !this.$v.costoEstimado.minValue) {
              this.costoEstimadoInvalidoMsj = 'El costo ingresado no es válido';
            }
          } else {
            this.costoEstimadoValido = null;
            this.costoEstimadoInvalidoMsj = '';
          }
        }
      } else {
        if (campo == 'costoEstimadoTotal' || validarTodos) {
          if (this.$v.costoEstimadoTotal.$error) {
            this.costoEstimadoTotalValido = false;
            if (!this.$v.costoEstimadoTotal.decimal || !this.$v.costoEstimadoTotal.minValue) {
              this.costoEstimadoTotalInvalidoMsj = 'El costo total ingresado no es válido';
            }
          } else {
            this.costoEstimadoTotalValido = null;
            this.costoEstimadoTotalInvalidoMsj = '';
          }
        }
      }
    },
    save () {
      let save = true;

      /* Antes de intentar registrar por primera vez, no validamos */
      this.noValidar = false;

      this.$v.$touch();

      if (this.$v.$anyError) {
        this.displayErrores();
      } else {
        if (save) {
          let dispatch = 'presupuestointerno/addOrdenAlternativa';
          if (!this.altaOrden) {
            dispatch = 'presupuestointerno/updateOrdenAlternativa';
          }
          this.$store.dispatch('ordenTrabajoAlternativa/save')
            .then(() => {
              return this.$store.dispatch(dispatch, this.ordenTrabajoAlternativa);
            })
            .then(() => this.$emit('closeOrdenAlternativa'))
            .catch(error => this.showErrorMsj(error));
        }
      }
    },
    goBack() {
      this.$emit('closeOrdenAlternativa');
    },
    calcularCostos() {
      if ((/true/i).test(this.costoUnitario)) {
        this.$store.dispatch('ordenTrabajoAlternativa/calcularCostoTotal');  
      } else {
        this.$store.dispatch('ordenTrabajoAlternativa/calcularCostoUnitario');
      }     
    },
    calcularCostoUnitario() {
      this.$store.dispatch('ordenTrabajoAlternativa/calcularCostoUnitario');
    },
    calcularCostoTotal() {
      this.$store.dispatch('ordenTrabajoAlternativa/calcularCostoTotal');
    }
  },
  watch: {
  },    
  validations: {
    titulo: {
      required,
      maxLength: maxLength(30)
    },
    descripcion: {
      maxLength: maxLength(5000)
    },
    cantidad: {
      numeric,
      minValue: minValue(0),
    },
    costoEstimado: {
      decimal,
      minValue: minValue(0)
    },
    costoEstimadoTotal: {
      decimal,
      minValue: minValue(0)
    },
  },  
}
</script>

<style>
  .custom-radio input[type='text'] {
    margin-left: 50%;
  }
</style>
